/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortfolioFieldRule } from './PortfolioFieldRule';
import {
    PortfolioFieldRuleFromJSON,
    PortfolioFieldRuleFromJSONTyped,
    PortfolioFieldRuleToJSON,
    PortfolioFieldRuleToJSONTyped,
} from './PortfolioFieldRule';
import type { PortfolioType } from './PortfolioType';
import {
    PortfolioTypeFromJSON,
    PortfolioTypeFromJSONTyped,
    PortfolioTypeToJSON,
    PortfolioTypeToJSONTyped,
} from './PortfolioType';
import type { PortfolioCreationFlow } from './PortfolioCreationFlow';
import {
    PortfolioCreationFlowFromJSON,
    PortfolioCreationFlowFromJSONTyped,
    PortfolioCreationFlowToJSON,
    PortfolioCreationFlowToJSONTyped,
} from './PortfolioCreationFlow';
import type { PortfolioManagedBy } from './PortfolioManagedBy';
import {
    PortfolioManagedByFromJSON,
    PortfolioManagedByFromJSONTyped,
    PortfolioManagedByToJSON,
    PortfolioManagedByToJSONTyped,
} from './PortfolioManagedBy';

/**
 * 
 * @export
 * @interface PortfolioTypeRule
 */
export interface PortfolioTypeRule {
    /**
     * 
     * @type {PortfolioType}
     * @memberof PortfolioTypeRule
     */
    portfolioType: PortfolioType;
    /**
     * Portfolio number prefix of this portfolio type, e.g. 02 in portfolio number 02.01.
     * @type {string}
     * @memberof PortfolioTypeRule
     */
    typeCode: string;
    /**
     * 
     * @type {PortfolioManagedBy}
     * @memberof PortfolioTypeRule
     */
    managedBy: PortfolioManagedBy;
    /**
     * Whether cash accounts may be created for portfolios of this type.
     * @type {boolean}
     * @memberof PortfolioTypeRule
     */
    cashAccountAllowed: boolean;
    /**
     * 
     * @type {PortfolioCreationFlow}
     * @memberof PortfolioTypeRule
     */
    creationFlow: PortfolioCreationFlow;
    /**
     * 
     * @type {Array<PortfolioFieldRule>}
     * @memberof PortfolioTypeRule
     */
    fields: Array<PortfolioFieldRule>;
}



/**
 * Check if a given object implements the PortfolioTypeRule interface.
 */
export function instanceOfPortfolioTypeRule(value: object): value is PortfolioTypeRule {
    if (!('portfolioType' in value) || value['portfolioType'] === undefined) return false;
    if (!('typeCode' in value) || value['typeCode'] === undefined) return false;
    if (!('managedBy' in value) || value['managedBy'] === undefined) return false;
    if (!('cashAccountAllowed' in value) || value['cashAccountAllowed'] === undefined) return false;
    if (!('creationFlow' in value) || value['creationFlow'] === undefined) return false;
    if (!('fields' in value) || value['fields'] === undefined) return false;
    return true;
}

export function PortfolioTypeRuleFromJSON(json: any): PortfolioTypeRule {
    return PortfolioTypeRuleFromJSONTyped(json, false);
}

export function PortfolioTypeRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioTypeRule {
    if (json == null) {
        return json;
    }
    return {
        
        'portfolioType': PortfolioTypeFromJSON(json['portfolioType']),
        'typeCode': json['typeCode'],
        'managedBy': PortfolioManagedByFromJSON(json['managedBy']),
        'cashAccountAllowed': json['cashAccountAllowed'],
        'creationFlow': PortfolioCreationFlowFromJSON(json['creationFlow']),
        'fields': ((json['fields'] as Array<any>).map(PortfolioFieldRuleFromJSON)),
    };
}

export function PortfolioTypeRuleToJSON(json: any): PortfolioTypeRule {
    return PortfolioTypeRuleToJSONTyped(json, false);
}

export function PortfolioTypeRuleToJSONTyped(value?: PortfolioTypeRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'portfolioType': PortfolioTypeToJSON(value['portfolioType']),
        'typeCode': value['typeCode'],
        'managedBy': PortfolioManagedByToJSON(value['managedBy']),
        'cashAccountAllowed': value['cashAccountAllowed'],
        'creationFlow': PortfolioCreationFlowToJSON(value['creationFlow']),
        'fields': ((value['fields'] as Array<any>).map(PortfolioFieldRuleToJSON)),
    };
}

